import React, { Component } from 'react';
import { connect } from 'react-redux';
import OverLay from '../ol/OverLay';

import styles from './info_window.scss';
import BrightnessGraph from '../profiles/BrightnessGraph';

import proj from 'ol/proj';
//{hoveredDevices && <h3 style={{position: 'absolute', bottom: 20, right: 20, color: 'white'}}>{JSON.stringify(hoveredDevices)}</h3>}

const InfoWindow = ({ mapInstance, hoveredDevice, profile }) => {
  if(!hoveredDevice)
    return null;

  return (
    <OverLay style={{ color: 'white', width: 300, border: '1px solid white', padding: 10, backgroundColor: 'rgba(0,0,0,0.7)'}} mapInstance={mapInstance} position={proj.fromLonLat([hoveredDevice.longitude, hoveredDevice.latitude])}>
      <h1>{hoveredDevice.name}</h1>
      <hr />
      <ul>
        <li><b>Serial number:</b> {hoveredDevice.serial_number}</li>
        {profile && <li><b>Profile:</b> {profile.name}</li>}
        <li><b>Pole:</b> {hoveredDevice.pole}</li>

      </ul>
    </OverLay>
  )
}

export default connect(state => {
  //console.log(state.devices.data.find(d => d.id === state.ui.map.hoveredDeviceIds[0]))
  const hoveredDevice = state.devices.data.find(d => d.id === state.ui.map.hoveredDeviceIds[0])
  return {
    hoveredDevice,
    profile: hoveredDevice ? state.profiles.data.find(p => p.id === hoveredDevice.profile_id) : null,
  };
})(InfoWindow)



// WEBPACK FOOTER //
// ./src/components/devices/InfoWindow.js